import dashboardicon from '../assets/images/menu-icons/dashboard.svg'
import activedashboardicon from '../assets/images/menu-icons/active-dashboard.svg'
import searchrates from '../assets/images/menu-icons/searchrates.svg'
import activesearchrates from '../assets/images/menu-icons/active-searchrates.svg'
import bookinghistory from '../assets/images/menu-icons/booking-history.svg'
import activebookinghistory from '../assets/images/menu-icons/active-booking-history.svg'
import airline_schedule_icon from "../assets/admin/images/airline_schedule.svg"
import queries from '../assets/images/menu-icons/queries.svg'
import activequeries from '../assets/images/menu-icons/active-queries.svg'
import { GrOrganization } from "react-icons/gr"
import Dashboard from '../pages/Dashboard'
import SearchRates from '../pages/SearchRates'
import BookingHistory from '../pages/BookingHistory'
import Queries from '../pages/Queries'
import PaymentRequest from '../pages/Admin/PaymentRequest'
import CreditInvoices from '../components/User/CreditInvoices'

// below this are admin routes
import AcceptedQuoteManagement from "../pages/Admin/AcceptedQuoteManagement"
import Archives from "../pages/Admin/Archives"
import CreateKeyAccountManager from "../pages/Admin/CreateKeyAccountManager"
import DashboardPage from "../pages/Admin/DashboardPage"
import ExchangeRate from "../pages/Admin/ExchangeRate"
import KYCVerifications from "../pages/Admin/KYCVerifications"
import Queriesadmin from "../pages/Admin/Queries"
import RateManagement from "../pages/Admin/RateManagement"
import RejectedQuoteManagement from "../pages/Admin/RejectedQuoteManagement"
// import Report from "../../pages/Admin/Report"
import TransportationRateManagement from "../pages/Admin/TransportationRateManagement"
import UserManagement from "../pages/Admin/UserManagement"
import UserManagementAdmin from "../pages/Admin/UserManagementAdmin"
import MarkupManagement from '../pages/Admin/MarkupManagement'
import OrganizationManagement from "../pages/Admin/OrganizationTable"
import userMangementCustomer from "../components/User/CustUserManagement/CustomeruserTable"
import FTLTransportationRateManagement from '../pages/Admin/FTLTransportationRateManagement'
import VehicleRateManagement from '../pages/Admin/VehicleRateManagement'
import CustomerContact from '../pages/User/CustomerContact'
import SubscriptionListManagement from '../components/Admin/SubscriptionManagement/SubscriptionListManagement'
import airlineproduct from '../components/Admin/AirlineProduct/AirlineproductMain'
import Newaircargodetail from '../components/BookingHistory/Newaircargodetail'
import Bookingdeletetable from '../components/BookingHistory/Bookingdeletepage/BookingDeletetable'
import AwbModule from '../components/Admin/AWB_Module/AwbModule'
import AirlineScheduleManagement from '../pages/Admin/AirlineScheduleManagement'
import SubscriptionTemplateManagement from '../components/Admin/SubscriptionTemplateManagement/TemplateSubscriptionManagement'
import NewSearchRates from '../pages/NewSearchRates'
import OceanApiLogs from '../pages/Admin/OceanApiLogs'
// KYB Manager back office (modules/kyb/manager)
// /kyb-manager itself is a standalone page (App.js); this entry only puts it in the admin menu.
import { KybConsoleEntry, KybManagerUsersPage } from '../modules/kyb/manager'
import CarrierManagement from '../components/Admin/CarrierManagement/CarrierManagement'

export const routs = [
    // {
    //     path: '',
    //     name: 'Dashboard',
    //     menuicon: dashboardicon,
    //     menuiconActive: activedashboardicon,
    //     role: ['customer'],
    //     component : Dashboard
    // },
    // {
    //     path: '/search-rates',
    //     name: 'Search Rates',
    //     menuicon: searchrates,
    //     menuiconActive: activesearchrates,
    //     role: ['customer', 'customer_admin'],
    //     component: SearchRates
    // },
    // air_admin sidebar: these come first, in this order; the rest follow below.
    {
        path: '/awbmanagement',
        name: 'AWB_Management',
        menuicon: bookinghistory,
        menuiconActive: activebookinghistory,
        role: ['air_admin'],
        component: AwbModule
    },
    {
        menuicon: airline_schedule_icon,
        menuiconActive: airline_schedule_icon,
        name: "Carrier Management",
        path: "/carrier-management",
        role: ['air_admin'],
        component: CarrierManagement
    },
    {
        menuicon: require("../assets/admin/images/SideBarIcons/user_management.png"),
        menuiconActive: require("../assets/admin/images/SideBarIcons/user_management_active.png"),
        name: "User Management",
        path: "/user-management-admin",
        role: ['air_admin'],
        component: UserManagementAdmin
    },
    {
        menuicon: require("../assets/admin/images/SideBarIcons/user_management.png"),
        menuiconActive: require("../assets/admin/images/SideBarIcons/user_management_active.png"),
        name: "Organization Management",
        path: "/organization-management",
        role: ['air_admin'],
        component: OrganizationManagement
    },
    {
        menuicon: require("../assets/admin/images/SideBarIcons/Vectorkyc.png"),
        menuiconActive: require("../assets/admin/images/SideBarIcons/Vectorkyc_active.png"),
        name: "KYC Verification",
        path: "/kyc-verification",
        role: ['air_admin'],
        component: KYCVerifications
    },
    {
        menuicon: require("../assets/admin/images/SideBarIcons/Vectorkyc.png"),
        menuiconActive: require("../assets/admin/images/SideBarIcons/Vectorkyc_active.png"),
        name: "KYB Manager",
        path: "/kyb-manager",
        // KYB reviews are done by KYB managers (and their reviewers) only —
        // ASAP admins no longer get this menu; they keep "KYB Managers".
        role: ['kyb_manager'],
        component: KybConsoleEntry
    },
    {
        menuicon: require("../assets/admin/images/SideBarIcons/create_key_account.png"),
        menuiconActive: require("../assets/admin/images/SideBarIcons/create_key_account_active.png"),
        name: "KYB Managers",
        path: "/kyb-manager-users",
        role: ['air_admin'],
        component: KybManagerUsersPage
    },
    {
        menuicon: require("../assets/admin/images/SideBarIcons/rate_management.png"),
        menuiconActive: require("../assets/admin/images/SideBarIcons/rate_management_active.png"),
        name: "Markup Management",
        path: "/markup-management",
        role: ['air_admin'],
        component: MarkupManagement
    },
    {
        menuicon: require("../assets/admin/images/SideBarIcons/create_key_account.png"),
        menuiconActive: require("../assets/admin/images/SideBarIcons/create_key_account_active.png"),
        name: "KAM Management",
        path: "/create-key-account-manager",
        role: ['air_admin'],
        component: CreateKeyAccountManager
    },
    {
        menuicon: require("../assets/admin/images/SideBarIcons/exchange_rate.png"),
        menuiconActive: require("../assets/admin/images/SideBarIcons/exchange_rate.png"),
        name: "Exchange Rate",
        path: "/exchange-rate",
        role: ['air_admin'],
        component: ExchangeRate
    },
    {
        menuicon: require("../assets/admin/images/SideBarIcons/reports.png"),
        menuiconActive: require("../assets/admin/images/SideBarIcons/report_active.png"),
        name: "Ocean API Logs",
        path: "/ocean-api-logs",
        role: ['air_admin'],
        component: OceanApiLogs
    },
    {
        path: '/search-rates',
        name: 'Search Rates',
        menuicon: searchrates,
        menuiconActive: activesearchrates,
        role: ['customer', 'customer_admin'],
        component: NewSearchRates
    },
    {
        path: '/queries',
        name: 'Queries',
        menuicon: queries,
        menuiconActive: activequeries,
        role: ['customer', 'customer_admin'],
        component: Queries
    },
    {
        menuicon: require("../assets/admin/images/SideBarIcons/queries_icon.png"),
        menuiconActive: require("../assets/admin/images/SideBarIcons/queries_active.png"),
        name: "Queries",
        path: "/QueriesKAM",
        role: ['kam', 'air_admin'],
        component: Queriesadmin
    },
    {
        menuicon: require("../assets/admin/images/SideBarIcons/user_management.png"),
        menuiconActive: require("../assets/admin/images/SideBarIcons/user_management_active.png"),
        name: "User Management",
        path: "/user-management",
        role: ['kam'],
        component: UserManagement
    },
    {
        path: '/bookingdeletehistory',
        name: 'Cancelled_Bookings',
        menuicon: bookinghistory,
        menuiconActive: activebookinghistory,
        role: ['customer', 'kam', 'air_admin'],
        component: Bookingdeletetable
    },
    {
        path: '/booking-history',
        name: 'Bookings',
        menuicon: bookinghistory,
        menuiconActive: activebookinghistory,
        role: ['customer', 'customer_admin'],
        component: BookingHistory
        //below this are admin routes
    },
    {
        path: '/credit-invoices',
        name: 'Credit Invoices',
        menuicon: bookinghistory,
        menuiconActive: activebookinghistory,
        role: ['customer', 'customer_admin'],
        component: CreditInvoices
    },
    {
        menuicon: require("../assets/admin/images/SideBarIcons/user_management.png"),
        menuiconActive: require("../assets/admin/images/SideBarIcons/user_management_active.png"),
        name: "User Management",
        path: "/user-management-customer",
        role: ['customer_admin'],
        component: userMangementCustomer
    },
    // {
    //     menuicon: require("../assets/admin/images/SideBarIcons/user_management.png"),
    //     menuiconActive: require("../assets/admin/images/SideBarIcons/user_management_active.png"),
    //     name: "Booking-view",
    //     path: "/booking-view",
    //     role: ['kam','air_admin','customer_admin','customer'],
    //     component: Newaircargodetail
    // }
    

    {
        menuicon: require("../assets/admin/images/SideBarIcons/dashboard.png"),
        menuiconActive: require("../assets/admin/images/SideBarIcons/dashboard_active.png"),
        name: "Dashboard",
        path: "/dashboard",
        role: ['air_admin'],
        component: DashboardPage
    },

    {
        menuicon: require("../assets/admin/images/SideBarIcons/user_management.png"),
        menuiconActive: require("../assets/admin/images/SideBarIcons/user_management_active.png"),
        name: "Airline product",
        path: "/airline-product",
        role: ['air_admin'],
        component: airlineproduct
    },
    {
        menuicon: require("../assets/admin/images/SideBarIcons/accepted_quotation.png"),
        menuiconActive: require("../assets/admin/images/SideBarIcons/accepted_quotation_active.png"),
        name: "Accepted Quotation Management",
        path: "/accepted-quotation-management",
        role: ['air_admin'],
        component: AcceptedQuoteManagement
    },
    {
        menuicon: require("../assets/admin/images/SideBarIcons/rejectedicon.png"),
        menuiconActive: require("../assets/admin/images/SideBarIcons/rejectedactive.png"),
        name: "Rejected Quotation Management",
        path: "/rejected-quotation-management",
        role: ['air_admin'],
        component: RejectedQuoteManagement
    },
    {
        menuicon: require("../assets/admin/images/SideBarIcons/rate_management.png"),
        menuiconActive: require("../assets/admin/images/SideBarIcons/rate_management_active.png"),
        name: "Rate Management",
        path: "/rate-management",
        role: ['air_admin'],
        component: RateManagement
    },
    {
        menuicon: require("../assets/admin/images/SideBarIcons/transportation.png"),
        menuiconActive: require("../assets/admin/images/SideBarIcons/transportationActive.png"),
        name: "Transportation Rate Management",
        path: "/transportation-rate-management",
        role: ['air_admin'],
        component: TransportationRateManagement
    },
    {
        menuicon: require("../assets/admin/images/SideBarIcons/transportation.png"),
        menuiconActive: require("../assets/admin/images/SideBarIcons/transportationActive.png"),
        name: "FTL Transportation Rate",
        path: "/ftl-transportation-rate-management",
        role: ['air_admin'],
        component: FTLTransportationRateManagement
    },
    {
        menuicon: require("../assets/admin/images/SideBarIcons/transportation.png"),
        menuiconActive: require("../assets/admin/images/SideBarIcons/transportationActive.png"),
        name: "Vehicle type",
        path: "/vehicle-type",
        role: ['air_admin'],
        component: VehicleRateManagement
    },
    {
        menuicon: require("../assets/admin/images/SideBarIcons/archives.png"),
        menuiconActive: require("../assets/admin/images/SideBarIcons/archives_active.png"),
        name: "Archives",
        path: "/archives",
        role: ['air_admin'],
        component: Archives
    },
    {
        menuicon: require("../assets/admin/images/SideBarIcons/payment_request.png"),
        menuiconActive: require("../assets/admin/images/SideBarIcons/payment_req_active.png"),
        name: "Payment Requests",
        path: "/payment-request",
        role: ['air_admin'],
        component: PaymentRequest
    }


    // {
    //     menuicon: require("../assets/admin/images/SideBarIcons/user_management.png"),
    //     menuiconActive: require("../assets/admin/images/SideBarIcons/user_management_active.png"),
    //     name: "Contact Management",
    //     path: "/contact-management",
    //     role: ['customer_admin'],
    //     component: CustomerContact
    // },

    // {
    //     menuicon: require("../assets/admin/images/SideBarIcons/payment_request.png"),
    //     menuiconActive: require("../assets/admin/images/SideBarIcons/payment_req_active.png"),
    //     name: "Subscription Management",
    //     path: "/subscription-list",
    //     role: ['customer_admin'],
    //     component: SubscriptionListManagement
    // }
    // ,
    // {
    //     menuicon: require("../assets/admin/images/SideBarIcons/payment_request.png"),
    //     menuiconActive: require("../assets/admin/images/SideBarIcons/payment_req_active.png"),
    //     name: "Subscription Template Management",
    //     path: "/subscription-template",
    //     role: ['customer_admin'],
    //     component: SubscriptionTemplateManagement
    // }
    ,
    {
        menuicon: airline_schedule_icon,
        menuiconActive: airline_schedule_icon,
        name: "Airline Schedules",
        path: "/airline_schedule",
        role: ['air_admin'],
        component: AirlineScheduleManagement
    }
    // ,
    // {
    //     icon: require("../assets/images/SideBarIcons/reports.png"),
    //     active_icon: require("../assets/images/SideBarIcons/report_active.png"),
    //     label: "Reports",
    //     path: "/reports",
    //     role: ['admin','air_admin','ocean_admin'],
    //     component: Report
    // }




]

export default routs